import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createVNode as _createVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeStyle as _normalizeStyle, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "M-Auto DialogContainer" }
const _hoisted_3 = { class: "DialogBody" }
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", {
  class: "D-Flex W-100",
  style: {"text-align":"left","margin-bottom":"15px","white-space":"nowrap"}
}, null, -1)
const _hoisted_5 = { class: "DialogSection" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_7 = { class: "DialogSection" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_9 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_10 = { class: "F-Bold F1_25em D-Flex" }
const _hoisted_11 = { class: "NOPRINT" }
const _hoisted_12 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_13 = { class: "P-Rel W-75 ItemsContainer" }
const _hoisted_14 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_15 = ["onBlur"]
const _hoisted_16 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_17 = ["onBlur"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_20 = { class: "DialogSection" }
const _hoisted_21 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSplitter" }, null, -1)
const _hoisted_22 = {
  id: "D_Profiles_Print",
  class: "DialogSection"
}
const _hoisted_23 = { class: "F-Bold F1_25em D-Flex" }
const _hoisted_24 = { class: "NOPRINT" }
const _hoisted_25 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_26 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_27 = ["onBlur"]
const _hoisted_28 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_29 = ["onBlur"]
const _hoisted_30 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_31 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_33 = /*#__PURE__*/_createElementVNode("div", { class: "BGColor3 H-100 O-15" }, null, -1)
const _hoisted_34 = ["onMousedown", "onTouchstart"]
const _hoisted_35 = /*#__PURE__*/_createElementVNode("div", { class: "CookiesRowSpacer" }, null, -1)
const _hoisted_36 = { class: "DialogSection" }
const _hoisted_37 = {
  key: 0,
  class: "CookiesDialogFooter"
}
const _hoisted_38 = {
  class: "F-Bold",
  style: {"margin":"auto 1em"}
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_DialogDisabler = _resolveComponent("DialogDisabler")!
  const _component_CookiesImageInput = _resolveComponent("CookiesImageInput")!
  const _component_CookiesNormalInput = _resolveComponent("CookiesNormalInput")!
  const _component_CookiesDescriptionBox = _resolveComponent("CookiesDescriptionBox")!
  const _component_CookiesIcon = _resolveComponent("CookiesIcon")!
  const _component_CookiesDropInputObject = _resolveComponent("CookiesDropInputObject")!
  const _component_vueQr = _resolveComponent("vueQr")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      id: 'CookiesDialog_' + _ctx.DialogIndex,
      class: "CookiesDialogdBody"
    }, [
      (_ctx.Loading.length > 0)
        ? (_openBlock(), _createBlock(_component_DialogDisabler, { key: 0 }))
        : _createCommentVNode("", true),
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _hoisted_4,
          _createElementVNode("div", _hoisted_5, [
            _createVNode(_component_CookiesImageInput, {
              onSelected: _cache[0] || (_cache[0] = ($event: any) => (_ctx.SaveData())),
              Folder: 'Catalogs',
              Res: 'D_Catalog_Image',
              style: {"border-radius":"var(--rad1)","width":"80%","height":"12em"}
            })
          ]),
          _hoisted_6,
          _createElementVNode("div", _hoisted_7, [
            _createVNode(_component_CookiesNormalInput, {
              onChanged: _cache[1] || (_cache[1] = ($event: any) => (_ctx.SaveData())),
              Placeholder: _ctx.Translate('Catalog Name'),
              CookiesInvalidInput: !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              ErrorData: _ctx.ErrorsVisibilty && !(_ctx.MEMRead('D_Catalog_Name') && _ctx.MEMRead('D_Catalog_Name') !== ''),
              Res: 'D_Catalog_Name',
              Default: ''
            }, null, 8, ["Placeholder", "CookiesInvalidInput", "ErrorData"]),
            _createVNode(_component_CookiesDescriptionBox, {
              onChanged: _cache[2] || (_cache[2] = ($event: any) => (_ctx.SaveData())),
              Placeholder: _ctx.Translate('Description'),
              Res: 'D_Catalog_Description'
            }, null, 8, ["Placeholder"])
          ]),
          _hoisted_8,
          _createElementVNode("div", _hoisted_9, [
            _createElementVNode("div", _hoisted_10, [
              _createElementVNode("span", _hoisted_11, _toDisplayString(_ctx.Translate('Categories')), 1)
            ]),
            _hoisted_12,
            _createElementVNode("div", _hoisted_13, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CookiesData?.Categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: category.ID,
                  class: "CategoryRow",
                  style: _normalizeStyle(`top: ${5 * index}em;`)
                }, [
                  _createVNode(_component_CookiesImageInput, {
                    Default: category.ImgURL,
                    onSelected: ($event: any) => (_ctx.EditImage(category, 'Categories', `D_Catalog_CategoryImage_${index}`)),
                    Res: `D_Catalog_CategoryImage_${index}`,
                    class: "Rad2",
                    style: {"border-radius":"var(--rad2)","width":"3.5em","height":"3.5em"}
                  }, null, 8, ["Default", "onSelected", "Res"]),
                  _hoisted_14,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditCategory($event, category, 'Name')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(category.Name), 41, _hoisted_15),
                  _hoisted_16,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditCategory($event, category, 'Description')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(category.Description), 41, _hoisted_17),
                  _hoisted_18,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      class: "SQR1_5em Pointer",
                      onClick: ($event: any) => (_ctx.RemoveItem(category, 'Categories')),
                      ID: 'Delete'
                    }, null, 8, ["onClick"])
                  ])
                ], 4))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.CookiesData?.Categories, (category, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "CategoryRowPlaceSaver"
                }))
              }), 128))
            ])
          ]),
          _hoisted_19,
          _createElementVNode("div", _hoisted_20, [
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.AddCategory())),
                Tooltip: _ctx.Translate('Add'),
                class: "M-Auto SQR2_5em Pointer",
                style: {"padding-inline-end":"0.5em"},
                ID: 'Add'
              }, null, 8, ["Tooltip"])
            ])
          ]),
          _hoisted_21,
          _createElementVNode("div", _hoisted_22, [
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("span", _hoisted_24, _toDisplayString(_ctx.Translate('Items')), 1)
            ]),
            _hoisted_25,
            _createElementVNode("div", {
              id: "CatalogItemsContainer",
              onTouchmove: _cache[4] || (_cache[4] = ($event: any) => (_ctx.IsTouching($event))),
              onMousemove: _cache[5] || (_cache[5] = ($event: any) => (_ctx.IsMoving($event))),
              style: _normalizeStyle(_ctx.GrappedItem ? 'user-select: none;' : ''),
              class: "P-Rel W-100 ItemsContainer"
            }, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MEMRead('D_Catalog_Items'), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: _normalizeClass([_ctx.GrappedItem?.ID === item?.ID ? 'ItemPlacer' : '', "ItemRow"]),
                  key: item.ID,
                  style: _normalizeStyle(`top: ${5 * index}em;`)
                }, [
                  _createVNode(_component_CookiesImageInput, {
                    Default: item.ImgURL,
                    onSelected: ($event: any) => (_ctx.EditImage(item, 'Items', `D_Catalog_ItemImage_${item.ID}`)),
                    Res: `D_Catalog_ItemImage_${item.ID}`,
                    class: "Rad2",
                    style: {"border-radius":"var(--rad2)","width":"3.5em","height":"3.5em"}
                  }, null, 8, ["Default", "onSelected", "Res"]),
                  _hoisted_26,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditItem($event, item, 'Code')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(item.Code), 41, _hoisted_27),
                  _hoisted_28,
                  _createElementVNode("span", {
                    onBlur: ($event: any) => (_ctx.EditItem($event, item, 'Name')),
                    contenteditable: "true",
                    class: "EditableText"
                  }, _toDisplayString(item.Name), 41, _hoisted_29),
                  _hoisted_30,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesDropInputObject, {
                      RowHeight: '3em',
                      Default: _ctx.CategoriesMap['Cat_' + item.CategorySeq]?.Name,
                      onSelected: ($event: any) => (_ctx.EditItemCategory(item, `D_CatalogEdit_${item.ID}`)),
                      Width: '12em',
                      Height: '1em',
                      class: "F_85em",
                      Res: `D_CatalogEdit_${item.ID}`,
                      Options: _ctx.CookiesData?.Categories,
                      Selectors: ['Name']
                    }, null, 8, ["Default", "onSelected", "Res", "Options"])
                  ]),
                  _hoisted_31,
                  (_ctx.$store.state.CookiesConfig.Catalog_MainURL)
                    ? (_openBlock(), _createBlock(_component_vueQr, {
                        key: 0,
                        style: {"width":"3em","height":"3em"},
                        text: `${_ctx.$store.state.CookiesConfig.Catalog_MainURL}/I/Q/${_ctx.CookiesData?.Sequence}/${item?.Sequence}`,
                        class: "Rad1 M-Auto",
                        size: 800
                      }, null, 8, ["text"]))
                    : _createCommentVNode("", true),
                  _hoisted_32,
                  _createElementVNode("div", null, [
                    _createVNode(_component_CookiesIcon, {
                      class: "SQR1_5em Pointer",
                      onClick: ($event: any) => (_ctx.RemoveItem(item, 'Items')),
                      ID: 'Delete'
                    }, null, 8, ["onClick"])
                  ]),
                  _hoisted_33,
                  _createElementVNode("span", {
                    onMousedown: ($event: any) => (_ctx.Grapped($event, item, index, 'Mouse')),
                    onTouchstart: ($event: any) => (_ctx.Grapped($event, item, index, 'Touch')),
                    class: "F-Bold F2em Color3 O-50 ObjectHolder"
                  }, "=", 40, _hoisted_34)
                ], 6))
              }), 128)),
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.MEMRead('D_Catalog_Items'), (item, index) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: index,
                  class: "ItemRowPlaceSaver"
                }))
              }), 128))
            ], 36)
          ]),
          _hoisted_35,
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", null, [
              _createVNode(_component_CookiesIcon, {
                onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.AddItem())),
                Tooltip: _ctx.Translate('Add Item'),
                class: "M-Auto SQR2_5em Pointer",
                style: {"padding-inline-end":"0.5em"},
                ID: 'Add'
              }, null, 8, ["Tooltip"])
            ])
          ])
        ])
      ])
    ], 8, _hoisted_1),
    (_ctx.Access(_ctx.DialogData.Editing ? 'Catalogue_Edit': 'Catalogue_Create'))
      ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
          _createElementVNode("div", _hoisted_38, [
            _createElementVNode("button", {
              class: _normalizeClass([_ctx.Saving ? 'Disabled' : '', "F-Bold CookiesButton DialogFooterButton"]),
              onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.$router.go(-1)))
            }, _toDisplayString(_ctx.Translate('Back')), 3)
          ])
        ]))
      : _createCommentVNode("", true)
  ], 64))
}